<template>
  <div class="animated fadeIn" v-if="isAdmin && items || !isAdmin && managerItems">
    <b-card>
      <template slot="header">
        <strong>Отчеты о статусе комплексной диагностики</strong>
      </template>
      <b-row>
        <b-col lg="12" v-if="isAdmin && items">
          <b-card>
            <template slot="header">
              <strong>Сводный отчет о статусе комплексной диагностики компаний</strong>
            </template>
            <b-row>
              <b-col lg="6">
                <b-table responsive striped bordered hover :items="items" :fields="fields">
                  <div slot="event_date" slot-scope="scope">
                    {{scope.item.event_date | formatDate}}
                  </div>
                  <div slot="edit" slot-scope="scope">
                    <router-link :to="'/complex-reports/region/' + scope.item.region_id" class="btn btn-success btn-sm">
                      <i class="fa fa-bar-chart"></i>
                    </router-link>
                  </div>
                </b-table>
              </b-col>
              <b-col lg="6">
                <div class="chart-wrapper">
                  <bar-complex-list-chart :items="items" type="admin" chartId="chart-bar-regions" />
                </div>
              </b-col>
            </b-row>
            <template slot="footer">
              <div class="text-right">
                <b-button variant="info" @click="print('admin')" class="text-white">
                  <i class="fa fa-print"></i> Печать
                </b-button>
              </div>
            </template>
          </b-card>
        </b-col>
        <b-col lg="12" v-if="managerItems">
          <div class="animated fadeIn">
            <b-card>
              <template slot="header">
                <b-form @submit.prevent="submit">
                  <ul class="list-inline">
                    <li class="list-inline-item">
                      <strong>По менеджерам</strong>
                    </li>
                    <li v-if="isAdmin" class="list-inline-item">
                      <autocomplete
                        input-class="form-control form-control-sm"
                        placeholder="Введите регион"
                        :source="regionUri"
                        v-model="region"
                        results-property="items"
                        @selected="selectedRegion"
                        results-display="region_name_ru">
                      </autocomplete>
                    </li>
                  </ul>
                </b-form>
              </template>
              <b-row>
                <b-col md="6">
                  <b-table responsive striped hover bordered :items="managerItems" :fields="managerFields">
                    <template slot="edit" slot-scope="data">
                      <router-link :to="'/complex-reports/' + region + '/manager/' + (data.item.id ? data.item.id : 'null')" class="btn btn-success btn-sm">
                        <i class="fa fa-bar-chart"></i>
                      </router-link>
                    </template>
                  </b-table>
                </b-col>
                <b-col md="6">
                  <BarComplexManagersListChart :items="managerItems" />
                </b-col>
              </b-row>
              <template v-if="managerItems.length" slot="footer">
                <div class="pull-right">
                  <b-button variant="info" @click="print('manager')" class="text-white">
                    <i class="fa fa-print"></i> Печать
                  </b-button>
                </div>
              </template>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <ComplexListPrint  class="print" type="admin" id="admin" :items="items"/>
    <ComplexManagersPrint class="print" id="manager" :items="managerItems" :region="regionName"/>
  </div>
</template>

<script>
    import * as AppStorage from '../../storage/appstorage';
    import client from "../../backend/client";
    import VerifyListPrint from "./VerifyListPrint";
    import Autocomplete from 'vuejs-auto-complete';
    import Config from '../../assets/config';
    import BarVerifyListChart from "../charts/BarVerifyListChart";
    import ComplexListPrint from "./ComplexListPrint";
    import BarComplexListChart from "../charts/BarComplexListChart";
    import BarComplexManagersListChart from "../charts/BarComplexManagersListChart";
    import ComplexManagersPrint from "./ComplexManagersPrint";
    export default {
        name: "ComplexList",
        components: {
            ComplexManagersPrint,
            BarComplexManagersListChart,
            BarComplexListChart, ComplexListPrint, VerifyListPrint,Autocomplete,BarVerifyListChart},
        data() {
            return {
                filters: {},
                user: JSON.parse(AppStorage.get('user')),
                isAdmin: false,
                items: null,
                fields: [
                    {
                        key: 'region',
                        label: 'Регион',
                        sortable: true
                    },
                    {
                        key: 'event_date',
                        label: 'Дата инф. мероприятия (в CRM)',
                        sortable: true
                    },
                    {
                        key: 'event_count',
                        label: 'Число участников инф. мероприятия (в CRM)',
                        sortable: true
                    },
                    {
                        key: 'progress_count',
                        label: 'В процессе диагностики',
                        sortable: true
                    },
                    {
                        key: 'archive_count',
                        label: 'Архив',
                        sortable: true
                    },
                    {
                        key: 'final_count',
                        label: 'Завершили диагностику',
                        sortable: true
                    },
                    {
                        key: 'edit',
                        label: 'Подробнее',
                        sortable: false
                    },
                ],
                region: null,
                regionName: null,
                regionUri: Config.API.url + '/api/regions?access_token=' + AppStorage.get('token') + '&filters[regionNameRu]=',
                managerItems: null,
                managerFields: [
                    {
                        key: 'user',
                        label: 'Менеджер',
                        sortable: true
                    },
                    {
                        key: 'progress_count',
                        label: 'В процессе диагностики',
                        sortable: true
                    },
                    {
                        key: 'archive_count',
                        label: 'Архив',
                        sortable: true
                    },
                    {
                        key: 'final_count',
                        label: 'Завершили диагностику',
                        sortable: true
                    },
                    {
                        key: 'edit',
                        label: 'Подробнее'
                    }
                ]
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                if(this.user.roles.indexOf('ROLE_SUPER_ADMIN') > -1) {
                    this.isAdmin = true;
                    client.get('api/crm/reports/regions', {
                        params: {
                            type: 'complex'
                        }
                    })
                        .then(res => {
                            this.items = res.data
                        })
                }

                this.region = this.user.region.id;
                this.regionName = this.user.region.region_name_ru;

                if(this.region) {
                    client.get('/api/crm/reports/' + this.region + '/complex/managers')
                        .then(res => {
                            this.managerItems = res.data
                        })
                }
            },
            print(idName) {
                let block = window.open('', 'PRINT');
                block.document.write('<html><head>');
                block.document.write('<style>@page { size: portrait;} body{ margin: 10mm 5mm 5mm 25mm; }</style>');
                block.document.write('</head><body>');
                block.document.write(document.getElementById(idName).innerHTML);
                block.document.write('</body></html>');
                block.document.close();
                block.focus();
                block.print();
                block.close();
                return true;
            },
            selectedRegion (region) {
                this.regionName = region.display;
                client.get('/api/crm/reports/' + region.value + '/complex/managers')
                    .then(res => {
                        this.managerItems = res.data
                    })
            },
            submit() {
                return;
            }
        }
    }
</script>

<style>
  .print {
    display: none;
  }
  .autocomplete__icon {
    height: auto!important;
  }
  .list-inline {
    margin-bottom: 0;
  }
  #chart-bar-regions {
    max-height: 692px!important;
  }
</style>
